import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IActivationServiceRequestTemplateModel } from '@apps-common/types/portal/service-request'

export const createUnitActivationTemplate = async (
  model: IActivationServiceRequestTemplateModel
): Promise<IActivationServiceRequestTemplateModel> =>
  axios.post(`/UnitActivation/CreateActivationTemplate`, model).then((res) => res?.data?.data)

type Props = {
  model: IActivationServiceRequestTemplateModel
}

export const useCreateUnitActivationTemplate = (notify?: boolean, onSuccess?: (data: IActivationServiceRequestTemplateModel) => void) =>
  useMutation({
    mutationKey: ['createUnitActivationTemplate'],
    mutationFn: ({ model }: Props) => createUnitActivationTemplate(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Created activation template.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to create activation template, please try again.')
      }
    },
    throwOnError: false
  })
